import { render, staticRenderFns } from "./buyTicket_3.vue?vue&type=template&id=4bd8b49e&scoped=true&"
import script from "./buyTicket_3.vue?vue&type=script&lang=js&"
export * from "./buyTicket_3.vue?vue&type=script&lang=js&"
import style0 from "./buyTicket_3.vue?vue&type=style&index=0&id=4bd8b49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8b49e",
  null
  
)

export default component.exports